import Styled from 'styled-components';

export const ListBulletElement = Styled.li`
  padding-left: 0.25em;
  margin: 0 0 0.5em;
  position: relative;

  &::before {
    content: '\\2022';
    position: absolute;
    color: ${({ theme }) => theme.text.colorBullet ? theme.text.colorBullet : theme.colorSlate};
    left: -0.75em;
    font-size: 2.5rem;
  }
`;

ListBulletElement.displayName = 'ListBulletElement';
